// Dimmed card for stopped grids — shows total PnL + trade count only.
import { useNavigate } from "react-router-dom";
import type { GridConfig } from "@/types/api";
import type { GridPnl } from "@/hooks/use-grid-pnl";
import { fmt } from "@/lib/format";

interface GridStoppedCardProps {
  grid: GridConfig;
  pnl: GridPnl | undefined;
}

export default function GridStoppedCard({ grid, pnl }: GridStoppedCardProps) {
  const navigate = useNavigate();
  const total = (pnl?.total_pnl ?? 0) + (pnl?.funding_total ?? 0);
  const totalColor = total >= 0 ? "#22c55e" : "#ef4444";

  return (
    <div
      className="bg-surface border border-border/50 rounded-lg p-3 cursor-pointer opacity-50 hover:opacity-70 transition-opacity"
      onClick={() => navigate(`/grid/${grid.id}`)}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="font-semibold text-sm text-dim">{grid.symbol}</span>
        <span className="text-[0.7rem] px-1.5 py-0.5 rounded bg-muted/20 text-muted">stopped</span>
      </div>
      <div className="text-[0.72rem] text-muted mt-1 flex gap-x-2">
        {pnl ? (
          <span>
            Total:{" "}
            <span className="font-semibold" style={{ color: totalColor }}>
              {total >= 0 ? "+" : ""}
              {fmt(total, 4)}
            </span>
            {" · "}
            {pnl.trade_count} cycle{pnl.trade_count === 1 ? "" : "s"}
          </span>
        ) : (
          <span>loading…</span>
        )}
      </div>
    </div>
  );
}
